import { reactive } from 'vue'
import _ from 'lodash'

export default function useDrag(rowId = 'id') {
  const state = reactive({})

  const resetDragging = () => {
    state.draggingData = { id: -1 }
    state.dragOnData = {}
  }
  resetDragging()

  const handleDragStart = (item) => {
    state.draggingData = item
  }
  const handleDragEnd = ({ items, callback, ...etc } = {}) => {
    if (state.dragOnData[rowId] && state.draggingData[rowId] !== state.dragOnData[rowId]) {
      const toIndex = items.findIndex((m) => m[rowId] === state.dragOnData[rowId])
      const fromIndex = items.findIndex((m) => m[rowId] === state.draggingData[rowId])

      const newItems = _.cloneDeep(items)
      newItems.splice(fromIndex, 1)
      newItems.splice(toIndex, 0, items[fromIndex])

      callback({ newItems, fromIndex, toIndex, ...etc })
    }
    resetDragging()
  }

  const handleDragOver = (dragOnData) => {
    state.dragOnData = dragOnData
  }

  return { state, handleDragStart, handleDragEnd, handleDragOver }
}
